import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="table-filters"
export default class extends Controller {

  export(e){
    e.preventDefault()

    const target = document.getElementById(this.element.dataset['formId'])
    if(!target){
      console.log('! NO TARGET FOR EXPORT !')
      return
    }

    const format = this.element.dataset['format']
    const default_action = target.action
    if(format) target.action = `${default_action}.${format}`

    target.requestSubmit()

    target.action = default_action
  }
}